import React, {
    Fragment,
    useEffect,
} from 'react'
import { useTranslation } from 'react-i18next'
import { Navigate } from 'react-router-dom'
import Flex from '../common/Flex'
import LoginForm from './LoginForm'
import withAuthSplit, { WithAuthSplitInjectedProps } from './withAuthSplit'
import { useAppSelector } from '../../hooks/redux'

const bgImg = '../images/loginImage.jpg'

interface LoginProps extends WithAuthSplitInjectedProps {
    loginRedirect: string
}

/**
 * Login page — redirects already-authenticated users and renders LoginForm.
 */
const Login = ({
    setBgProps,
    loginRedirect,
}: LoginProps) => {
    const authedUser = useAppSelector(state => state.auth.user)
    const [t] = useTranslation()

    useEffect(
        () => setBgProps({ image: bgImg, position: '50% 20%' }),
        [setBgProps],
    )

    if (authedUser) {
        return <Navigate to={loginRedirect} replace />
    }

    return (
        <Fragment>
            <Flex align='center' justify='between'>
                <h3>
                    {t('auth.login')}
                </h3>
            </Flex>
            <LoginForm layout='split' hasLabel />
        </Fragment>
    )
}

export default withAuthSplit(Login)
